import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

export class SelectiveLoadRouteStrategy implements PreloadingStrategy {
  routes: { [name: string]: { route: Route; load: () => Observable<any> } } =
    {};

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data['name']) {
      this.routes[route.data['name']] = {
        route,
        load,
      };
    }
    return of(null);
  }

  preLoadRoute(name: string) {
    const route = this.routes[name];
    if (route) {
      route.load();
    }
  }
}
